export default __webpack_public_path__ + "static/media/p11.2bb67535.jpeg";